var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portal-top-nav" }, [
    _c("header", { staticClass: "portal-header" }, [
      _c(
        "div",
        {
          staticClass: "brand-zone",
          class: { "is-collapsed": !_vm.$store.state.leftNavExpanded }
        },
        [
          _c(
            "button",
            {
              staticClass: "brand-link",
              attrs: { type: "button", "aria-label": _vm.accountName },
              on: {
                click: function($event) {
                  return _vm.$router.push("/welcome")
                }
              }
            },
            [
              _vm.logo
                ? _c("img", {
                    staticClass: "brand-logo",
                    attrs: { src: _vm.logo, alt: _vm.accountName }
                  })
                : _c(
                    "span",
                    {
                      staticClass: "brand-fallback",
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v(_vm._s(_vm.accountInitial))]
                  )
            ]
          ),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { placement: "right", boundary: "window" },
                  expression: "{ placement: 'right', boundary: 'window' }"
                }
              ],
              staticClass: "collapse-control d-none d-sm-flex",
              attrs: {
                type: "button",
                "aria-label": _vm.$store.state.leftNavExpanded
                  ? _vm.$t("nav.collapse-navigation")
                  : _vm.$t("nav.expand-navigation"),
                content: _vm.$store.state.leftNavExpanded
                  ? _vm.$t("nav.collapse-navigation")
                  : _vm.$t("nav.expand-navigation")
              },
              on: { click: _vm.toggleLeftNav }
            },
            [
              _c("portal-icon", {
                attrs: {
                  name: _vm.$store.state.leftNavExpanded
                    ? "panel-left-close"
                    : "panel-left-open",
                  size: 19
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "header-navigation" },
        [
          _vm.hasContextNavigation
            ? _c("tabs", {
                attrs: {
                  "tab-config": _vm.currentTabsConfig,
                  "current-path": _vm.currentPath
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c("div", { staticClass: "d-none d-sm-flex" }, [
            _c(
              "button",
              {
                staticClass: "header-action",
                class: {
                  active:
                    _vm.$store.state.rightNavExpanded &&
                    _vm.$store.state.rightNavFocus === "notifications"
                },
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("nav.notifications")
                },
                on: {
                  click: function($event) {
                    return _vm.openRightNav("notifications")
                  }
                }
              },
              [
                _c("portal-icon", { attrs: { name: "bell", size: 21 } }),
                _vm.$store.state.actionCount
                  ? _c("span", { staticClass: "notification-count" }, [
                      _vm._v(_vm._s(_vm.$store.state.actionCount))
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm.mobile
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    left: "",
                    "content-class": "portal-notification-menu"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "header-action",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.$t("nav.notifications")
                                    }
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("portal-icon", {
                                  attrs: { name: "bell", size: 21 }
                                }),
                                _vm.$store.state.actionCount
                                  ? _c(
                                      "span",
                                      { staticClass: "notification-count" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$store.state.actionCount)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    303690923
                  )
                },
                [
                  _c(
                    "div",
                    { staticClass: "mobile-notifications" },
                    [_c("notifications")],
                    1
                  )
                ]
              )
            : _vm._e(),
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "", left: "", "content-class": "user-menu" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "button",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "profile-button",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t("nav.open-profile-menu")
                              }
                            },
                            "button",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("span", { staticClass: "profile-avatar" }, [
                            _vm._v(_vm._s(_vm.initials))
                          ]),
                          _c(
                            "span",
                            { staticClass: "profile-name d-none d-sm-inline" },
                            [_vm._v(_vm._s(_vm.firstName))]
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            },
            [_c("user-menu")],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }